/**
 * @since 2018/9/7
 * @author fanjingjian
 */
import { parse } from 'qs';
export const DEFAULT_BACKEND_RESPONSE_CODE_IN_DATA = 200;
export const PC_ERROR_REPORT_CLIENTTYPE = 220;
export const PC_ERROR_REPORT_DEFAULT_CLIENT = () => {
  let jumpFromOld = parse(window.location.search.split('?')[1]);
  if (jumpFromOld.client) {
    return jumpFromOld.client;
  } else {
    return 'SALES_PC';
  }
};
export const PC_ERROR_REPORT_DEFAULT_OUTID = () => {
  let jumpFromOld = parse(window.location.search.split('?')[1]);
  if (jumpFromOld.outId) {
    return { outId: parseInt(jumpFromOld.outId) };
  } else {
    return null;
  }
};
export const mapAccurateStatus = {
  0: '未校准',
  1: '已校准',
  2: '机器已校准',
};
export const mapStatus = {
  1: '已关',
  2: '暂停营业',
  3: '非激活',
  4: '尚未营业',
  5: '正常',
  6: '积分商户',
  7: '尚未营业',
  8: '屏蔽商户（侵权）',
};

export const mapUseType = {
  1: '正常商户',
  2: '测试商户',
  3: '虚拟商户',
  4: '泛搜索专用商户',
  5: '阿波罗专用商户',
  6: '虚假商户',
  11: '美团未认证',
  13: '垃圾商户',
  15: '违规侵权屏蔽商户',
  16: '美团商品部专用',
  17: '先审后发畸形新增审核中的商户',
  18: '先审后发畸形新增审核驳回的商户',
  19: '僵尸商户',
  20: '重复商户',
  21: '涉黄商户',
  22: '无证经营商户',
  23: '违反广告法商户',
  24: '特殊不展示POI',
  25: '美团支付专用POI',
  26: '洗浴按摩品类点评管家审核中状态',
  27: '食安使用',
  28: '食安使用',
  29: '食安使用',
};

export const defaultSearchResultToActionList = [
  {
    path: '/errors/base-info',
    text: '基本信息报错',
    menuType: 1,
  },
  {
    path: '/errors/parent',
    text: '父子关系报错',
    menuType: 6,
  },
  {
    path: '/errors/shop-status',
    text: '门店状态报错',
    menuType: 10,
  },
  {
    path: '/errors/fake-info',
    text: '举报虚假商户',
    menuType: 9,
  },
  {
    path: '/errors/shop-relations',
    text: '门店匹配关系报错',
    menuType: 13,
  },
  {
    path: '/errors/guide',
    text: '路引信息修改',
  },
  {
    path: '/errors/wedding',
    text: '婚宴副本相关',
    menuType: 8,
  },
  {
    path: '/errors/shop-tag',
    text: '标签信息报错',
    menuType: 7,
  },
  {},
  {
    path: '/errors/repeat/merge',
    text: '合并重复门店',
    menuType: 12,
  },
  {
    path: '/errors/repeat/split',
    text: '拆分重复门店',
    menuType: 12,
  },
  {},
  {
    path: '/errors/groups/new-group',
    text: '新增连锁门店',
  },
  {
    path: '/errors/groups/remove-group',
    text: '解除连锁门店',
  },
  {
    path: '/errors/groups/add-groups',
    text: '添加连锁关系',
  },
  {},
  {
    path: '/errors/groupon/service',
    text: '上门服务报错',
  },
];

export function getMenuByPath(pathname) {
  const selectedItem = defaultSearchResultToActionList.find(item => item.path === pathname);
  return selectedItem;
}

// 按照路由映射以下两者的关系：当前报错类型需要单选一家门店；可以多选多家门店
export const mapSearchResultToAction = {
  '/search/poi': {
    actionList: defaultSearchResultToActionList,
    // rowSelectionType: null,
    // rowSelectionType: 'checkbox',
  },
  '/errors': {
    rowSelectionType: null,
    // rowSelectionType: 'radio',
    actionList: defaultSearchResultToActionList,
  },
};

export const SHOP_IMAGE_UPLOAD_EXAMPLES =
  'https://p1.meituan.net/dpgroup/d80fa1d9a7e750dd227b790a8f1da962807591.png';

export const SHOP_SIGN_UPLOAD_EXAMPLES =
  'https://p1.meituan.net/dpgroup/6fde903c5b16eb71e71c564973a892eb370610.png';

export const SHOP_GROUP_UPLOAD_EXAMPLES =
  'http://p0.meituan.net/dpgroup/c3954f60cda6c04f04add6ba1c67328e180852.jpg';
export const SHOP_IMG_EXAMPLES =
  _ENVIRONMENT === 'beta'
    ? '//e.51ping.com/poi/bpc/dp/report-demo'
    : '//e.dianping.com/poi/bpc/dp/report-demo';
export const SHOP_STATUS_IMG_EXAMPLES = `//e.${
  _ENVIRONMENT === 'beta' ? '51ping' : 'dianping'
}.com/poi/bpc/dp/report-demo-shop-status`;
export const BIZ_TIME_ACTIVITY_DEMO =
  _ENVIRONMENT === 'beta' || _ENVIRONMENT === 'development'
    ? '//e.51ping.com/poi/bpc/dp/biztime-activity-demo'
    : '//e.dianping.com/poi/bpc/dp/biztime-activity-demo';
export const ADD_SHOP_QUALIFICATIONS_DEMO = `//e.${
  _ENVIRONMENT !== 'product' ? '51ping' : 'dianping'
}.com/poi/bpc/dp/report-demo-duplicate`;
export const SHOP_TAG_PROMISE = `//e.${
  _ENVIRONMENT === 'beta' ? '51ping' : 'dianping'
}.com/poi/bpc/dp/tag/promise`;
export const ONLINE_DELIVERY_SHOP_DESCRIPTION =
  _ENVIRONMENT === 'beta'
    ? 'https://e.51ping.com/poi/bpc/dp/online-delivery-description'
    : 'https://e.dianping.com/poi/bpc/dp/online-delivery-description';

export const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 3 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
    md: { span: 10 },
  },
};

// 服务范围颜色配置：https://ingee.meituan.com/#/detail/18062
export const ServiceAreaColor = [
  '#8fc351',
  '#fec12d',
  '#1fb5fc',
  '#fd6a9c',
  '#fd8944',
  '#28e8e9',
  '#f3423b',
  '#1db4a2',
  '#9333af',
  '#4153b8',
  '#f0b7bd',
  '#78a7a3',
  '#a59fd3',
  '#c8daa6',
  '#5e92c7',
  '#98d0dd',
  '#cfc191',
  '#cd87b4',
  '#d18b76',
  '#fad784',
  '#8fc351',
  '#fec12d',
  '#1fb5fc',
  '#fd6a9c',
  '#fd8944',
  '#28e8e9',
  '#f3423b',
  '#1db4a2',
  '#9333af',
  '#4153b8',
  '#f0b7bd',
  '#78a7a3',
  '#a59fd3',
  '#c8daa6',
  '#5e92c7',
  '#98d0dd',
  '#cfc191',
  '#cd87b4',
  '#d18b76',
  '#fad784',
];

// 区域类型
export const AreaTypes = {
  city: {
    id: 1,
    name: '全城',
  },
  polygon: {
    id: 3,
    name: '多边形区域',
  },
  circle: {
    id: 2,
    name: '圆形区域',
  },
};

export const emptyArea = {
  type: 3,
  cityId: '',
  radius: 0,
  center: {
    lng: 121.414318,
    lat: 31.244522,
  },
  path: [],
};

// 到店门店类型
export const SHOP_TYPES = {
  shop: 0, // 到店类
  mixture: 1, // 混合类
  visit: 2, // 纯上门
};

export const maxRadius = 5000;

/*
* 后台一级品类：不展示准确性状态字段
* 到餐：餐饮
* 到综：休闲娱乐、丽人、结婚、教育培训、爱车、运动健身、家装、购物、亲子、医疗、生活服务、会议宴会、K歌、宠物、交通枢纽
*/
export const groupCates = [289, 226, 2, 450, 3, 388, 4, 389, 1861, 390, 2506, 206, 600, 379, 1853];

export const ROLE = {
  SALES: '2',
  CUSTOM_SERVICE: '8',
  CALL_CENTER_SERVICE: '9',
};

export const EXIF_FILED_NAME = 'exifInfo';

export function getCurrentMenuAuthItem(location, searchPoiResult) {
  const { pathname } = location;
  const currentMenu = getMenuByPath(pathname);
  // 当前页面的操作权限
  const menuAuthItem =
    currentMenu &&
    (searchPoiResult?.menuAuthCheckList || []).find(item => item.menuType === currentMenu.menuType);
  return menuAuthItem;
}
